import Mustache from 'mustache';
import galleryModalHtml from './_modal.html';
import './style.scss';

class GalleryModal {
    constructor(params) {
        this.settings = {
            ...this.defaults(),
            ...params,
        }
        this.init();
    }

    defaults(){
        return {
            imgList: [],
            overlayClose: true,
        }
    }

    init(){
        const rendered = Mustache.render(galleryModalHtml, {
            imgList: this.settings.imgList,
        });
        const modalObj = document.createElement('div');
        modalObj.innerHTML = rendered;
        document.querySelector('body').appendChild(modalObj);

        document.querySelector('.plugin-gallery-modal__close').addEventListener('click', (e) => {
            this.close();
        });
        if(this.settings.overlayClose){
            document.querySelector('.plugin-gallery-modal__overlay').addEventListener('click', (e) => {
                this.close();
            });
        }
    }

    close(){
        document.querySelector('html').classList.remove('is-fixed');
        document.querySelector('.plugin-gallery-modal').classList.remove('is-show');
        setTimeout(() => {
            document.querySelector('.plugin-gallery-modal__content').scrollTop = 0;
        }, 500);
    }

    show(index = 1){
        const targetItem = document.querySelectorAll('.plugin-gallery-modal__content .plugin-gallery-modal-content__item')[index];
        let pos = targetItem.getBoundingClientRect().top;
        const contentHeight = document.querySelector('.plugin-gallery-modal__content').clientHeight;
        const imgHeight = targetItem.querySelector('img').clientHeight;
        const windowHeight = window.innerHeight;
        pos -= (windowHeight - contentHeight) / 2;
        if (imgHeight < contentHeight) {
            pos -= (contentHeight - imgHeight) / 2;
        }
        document.querySelector('.plugin-gallery-modal__content').scrollTop = pos;
        document.querySelector('.plugin-gallery-modal').classList.add('is-show');
        document.querySelector('html').classList.add('is-fixed');
    }
}

export default GalleryModal;
